
//65
Object.defineProperty(exports, "__esModule", { value: true });

        module.exports.default = require("stylable/runtime").create(
    "root",
    "opacity1624322276",
    {"root":"opacity1624322276--root","opacity06":"rgba(255, 255, 255, 0.06)","opacity12":"rgba(255, 255, 255, 0.12)","opacity18":"rgba(255, 255, 255, 0.18)","opacity24":"rgba(255, 255, 255, 0.24)","opacity30":"rgba(255, 255, 255, 0.30)","opacity36":"rgba(255, 255, 255, 0.36)","opacity42":"rgba(255, 255, 255, 0.42)","opacity48":"rgba(255, 255, 255, 0.48)","opacity66":"rgba(255, 255, 255, 0.66)","opacity90":"rgba(255, 255, 255, 0.90)","opacity96":"rgba(255, 255, 255, 0.96)"},
    null,
    module.id
);



//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/themes/backoffice/opacity.st.css
// module id = 1365
// module chunks = 0